export default "__VITE_ASSET__CIIwXMr6__"